import axios from 'axios';
import { WELCOME_TOAST_SHOWN_KEY } from '@features/Auth/Welcome';
import { actions } from '@shared/store/ducks';
import { useAppDispatch } from '@shared/store';
import { baseApi } from '@shared/store/api/baseApi';
import { useNavigate } from 'react-router-dom';
import { UnauthenticatedPath } from '@shared/constants/routes.constants';
import { VITE_API_URL } from '@shared/constants/environments';

export const useSignOut = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onLogout = async () => {
    // The staging OpenAPI spec does not publish a sign-out mutation, so this
    // cannot go through the generated client. Best-effort: the person leaves
    // the app either way, and a failed call only means the cookie outlives
    // the session, which is no worse than not calling at all.
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${VITE_API_URL}/v1/user/sign-out`,
        {},
        {
          withCredentials: true,
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        },
      );
    } catch (error) {
      console.error('Sign-out request failed:', error);
    }

    sessionStorage.removeItem(WELCOME_TOAST_SHOWN_KEY);
    localStorage.removeItem('firstLogin');
    dispatch(actions.auth.signOut());
    dispatch(baseApi.util.resetApiState());
    navigate(UnauthenticatedPath.SIGN_IN);
  };

  return onLogout;
};
